import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { PagedResponse } from "../../types/Result";
import { User } from "../user/type";

export const userListLoader: LoaderFunction = async (args) => {
  let url = new URL(args.request.url);
  const result = await axiosApi.get<PagedResponse<User>>(
    url.search
      ? `/api/users${url.search}`
      : "/api/users?sort.field=creationTime&sort.sort=desc"
  );
  return result.data;
};
